import { gql } from 'graphql-tag'

const imageFragment = gql`
  fragment ImageFragment on Image {
    station {
      id
      name
    }
    type
    content
    id
  }
`

export const addMonthlyInfoImage = gql`
  mutation AddMonthlyInfoImage($stationId: ID, $type: String!, $file: String!) {
    addImage(stationId: $stationId, type: $type, file: $file)
  }
`

export const fetchMonthlyInfoImages = gql`
  query FetchMonthlyInfoImages($stationId: ID!, $type: String!) {
    images(stationId: $stationId, type: $type) {
      ...ImageFragment
    }
  }
  ${imageFragment}
`

export const deleteMonthlyInfoImage = gql`
  mutation DeleteMonthlyInfoImage($imageId: ID!) {
    deleteImage(imageId: $imageId)
  }
`
